<template>
  <NuxtLayout>
    <div class="error-page">
      <h1 class="error-page__code">
        {{ error.statusCode }}
      </h1>
      <p class="error-page__text">
        {{ displayedErrorMessage }}
      </p>
      <button
        type="button"
        class="error-page__button"
        @click="goHome"
      >
        На главную
      </button>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const { error } = defineProps<{ error: NuxtError }>();
const isDev = Boolean(useRuntimeConfig().public.isDev);

const displayedErrorMessage = computed(() => {
  if (isDev) {
    return error.statusMessage || error.message || 'Что-то пошло не так.';
  }
  if (error.statusCode === 404) return 'Хм, такую страницу найти не удалось.';
  return 'Что-то пошло не так.';
});

const goHome = () => {
  clearError({ redirect: '/' });
};
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 24px;
  text-align: center;
}

.error-page__code {
  margin: 0 0 16px;
  color: #111;
  font-size: 8rem;
  font-weight: 800;
  line-height: 0.9;
}

.error-page__text {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
}

.error-page__button {
  margin-top: 32px;
  padding: 12px 28px;
  border: 0;
  border-radius: 0;
  color: #111;
  background: #ffcc00;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
}
</style>
